// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mZlT","title":"styles_title__2YSoB"};